module.exports = __webpack_public_path__ + "img/1.ea8e71d8.jpg";